import { DialogContent, Dialog, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitleWithClose, Documents, Loader } from 'ui';

type HomeCoveredBondsDocumentsModalProps = {
  isPending: boolean;
  documents: Document[];
  open: boolean;
  onClose: () => void;
};

type Document = {
  link: string;
  name: string;
  publicationDate: string;
};

export const HomeCoveredBondsDocumentsModal: FC<HomeCoveredBondsDocumentsModalProps> = ({
  isPending,
  documents,
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  const documentsParsed = documents.map((document: Document) => {
    const { link, name, publicationDate } = document;
    return {
      path: link,
      name,
      publicationDate,
      title: name,
    };
  });

  const documentsDisplay = documents.length ? (
    <Documents expanded title={t('Reports')} documents={documentsParsed} />
  ) : (
    <Typography variant="caption">{t('No documents to display')}</Typography>
  );

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth={false}>
        <DialogTitleWithClose onClose={onClose}>{t('DOCUMENTS')}</DialogTitleWithClose>
        <DialogContent>{isPending ? <Loader center /> : documentsDisplay}</DialogContent>
      </Dialog>
    </>
  );
};
